/**
 * BulkDeductionTable — LiveView hook for inline-editable deduction item tables.
 *
 * Built on createBulkTableHook for shared behavior (dirty tracking, defaults,
 * save, errors, filtering). No computed fields — simpler than BulkEarningTable.
 *
 * Only customization: a row must have a deduction_type_id selected to be valid.
 */

import createBulkTableHook, { type RowData } from "./createBulkTableHook";

const BulkDeductionTable = createBulkTableHook({
  isRowValid: (rowData: RowData) => !!rowData["value"],
});

export default BulkDeductionTable;
